<template>
  <modal color="success" size="lg" :title="$t('nameTranslation')" :loading="true" :show.sync="localShowModal"
    :footer="false" centered>
    <CCard >
      <CCardBody style="min-height: 450px;" >
        <CRow className="justify-content-between">
          <CCol>
            <h5 class="text-dark mb-1">
              {{ $t("nameTranslation") }}
              <span class="text-info h5">
                <CIcon name="cil-language" color="info" />
              </span>
            </h5>
          </CCol>
          <!-- <CCol>
            <div class="token-balance d-flex align-items-center justify-content-end mb-2 pr-2">
              <img src="/img/languages/silom-token.png" alt="token" style="width: 18px; height: 18px;" class="mr-1" />
              <span class="text-success font-weight-bold">{{ remainingTokens }}</span>
            </div>
          </CCol> -->
        </CRow>
        
       
        <!-- <p class="text-grey mb-0 mt-2">{{ $t("nameTran") }}</p> -->
        <CRow>
          <CCol col="12">
            <CInput v-model="defaultTranslation" class="text-black mb-2" disabled />
          </CCol>
        </CRow>
        <CRow >
          <!-- <div class="col-xl-4 col-lg-4 col-sm-4 col-6">
            <CButton block color="success" :disabled="isTranslating" @click="getTranslationAll">
              <img :src="isHovered ? '/img/languages/Ai_W.png' : '/img/languages/Ai_W.png'" style="width: 20px; height: 20px; margin-left: 8px;" /> {{ isTranslating ? $t('translating') : $t('translateAll') + ' ( ~' + totalTokenCount + ' ' }}
              <img v-if="!isTranslating" src="/img/languages/silom-token.png" alt="token" style="width: 18px; height: 18px; margin: 0 4px;" />
              <span v-if="!isTranslating">)</span>
            </CButton>
          </div> -->
          <!-- col-xl-8 col-lg-8 col-sm-8  col-6 -->
          <div class="col-xl-12 col-lg-12 col-sm-12  col-12 text-left">
            <!-- <select v-model="newLanguage" @change="addLanguage" class="form-control" :disabled="availableLanguages.length <= 0">
              <option disabled value="">{{ $t('addMoreLanguage') }}</option>
              <option v-for="lang in availableLanguages" :key="lang.value" :value="lang">
                <img :src="lang.img" :alt="lang.name" class="lang-icon" /> {{ lang.name }}
              </option>
            </select> -->
            <multiselect
              ref="langSelect"
              :options="availableLanguages"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="true"
              track-by="value"
              label="name"
              :placeholder="$t('addMoreLanguage')"
              :disabled="availableLanguages.length <= 0"
              @input="onSelectLanguage"
            >
              <!-- แสดงรูปธง + ชื่อในรายการ -->
              <template #option="{ option }">
                <div class="lang-option">
                  <img :src="option.img" :alt="option.name" class="lang-flag"/>
                  <span>{{ option.name }}</span>
                </div>
              </template>

              <!-- แสดงรูปธง + ชื่อเมื่อถูกเลือก -->
              <template #singleLabel="{ option }">
                <div class="lang-option">
                  <img :src="option.img" :alt="option.name" class="lang-flag"/>
                  <span>{{ option.name }}</span>
                </div>
              </template>
            </multiselect>
          </div>
        </CRow>
        <div v-if="Array.isArray(translations) && translations.length > 0" class="card-body-background">
          <hr style="border-top-color: #29b289;" />
          <!-- <CAlert  color="success" class="d-inline-block col-12 mt-0 mb-2">
                <div class="d-flex">
                    <div class="flex-shrink-0">
                        <i class="fi fi-rr-info mr-1 text-warning"></i>
                    </div>
                    <div class="flex-grow-1 ms-3 ml-2">
                        <p class="m-0">{{ $t('แปลชื่อเมนูได้ไวด้วย AI !') }}</p>
                        <p class="m-0">{{ $t('แค่คลิกเดียว AI จะช่วยแปลชื่อเมนูของคุณไปยังหลายภาษาอัตโนมัติ ง่าย เร็ว และแม่นยำ 🎯   ') }}</p>
                        <p class="mb-0 text-muted">
                          * ทุกการแปลจะใช้ <img src="/img/languages/silom-token.png" alt="Token" style="width: 18px; height: 18px;" /> Token ในระบบ 
                          <b>Silom Smart</b>. 
                          <span>สามารถเติม Token ได้ที่ <a href="https://smart.silompos.com" target="_blank">smart.silompos.com</a></span>
                        </p>

                    </div>
                </div>
            </CAlert> -->
          <div v-for="(input, index) in translations"
            :key="index" class="d-flex align-items-start mb-3">
            <div class="flex-fill">
              <div class="language-input-with-icon mb-0">
        
                <img :src="input.img" class="language-icon lang-icon "  />
                <input
                  type="text"
                  class="form-control" style="padding-left: 48px;"
                  v-model="input.description"
                  :placeholder="`Enter product name (${defaultTranslation || 'undefined'})`"
                  :ref="'descName-' + index"
                  :class="[input.isAnimating ? 'soft-blink' : 'no-blink']"
                  :readonly="input.isAnimating"
                  :disable="input.isAnimating"
                  :key="input.isAnimating + '-' + index"
                  :dir="isRTL(input.value) ? 'rtl' : 'ltr'"
                />
                <!-- <span class="ai-icon" @click="getTranslation(index)">
                  <span  :class="[input.loading ? 'soft-blink' : '','shake-on-hover']" > 
                    <img src="/img/languages/Ai.png"  style="width: 25px; height: 25px;" /> 
                  </span>
                </span> -->
              </div>

              <div class="d-flex justify-content-between align-items-center ">
                <div class="custom-control custom-checkbox mt-1">
                  <input type="checkbox" class="custom-control-input" 
                    v-model="input.isTheSame" :id="'checkbox-' + index"
                    @change="handleCheckboxChange(input)" />
                  <label class="custom-control-label cursor" :for="'checkbox-' + index">
                    {{ $t('useDefault') }}
                  </label>
                </div>
                <div class="text-dark cursor-pointer cursor" 
                  @click="getTranslation(index)" 
                  :class="[input.loading ? 'soft-blink' : '','shake-on-hover']"
                  v-if="input.description === ''"
                >

                  <!-- <span class="mr-1">{{ $t('translateByAI') }}</span> -->
                  <!-- <img src="/img/languages/Ai_G.png" style="width: 20px; height: 20px;" class="mr-1" /> -->
                  <!-- ✅ แสดง estimate ถ้ามี -->
                  <template v-if="estimatedCosts[input.value]" class="font-weight-normal text-center">
                    <!-- badge badge-success border -->
                    <span class="badge badge-light  text-center  ml-1 mt-1 font-weight-normal" style="font-size: 85%;">
                      
                      ~ {{ estimatedCosts[input.value].tokenCount }}  <img src="/img/languages/silom-token.png" style="width: 16px; height: 16px;" class="mr-1" />
                       <!-- (  ${{ estimatedCosts[input.value].estimatedCost.toFixed(6) }}) -->
                    </span>
                    <!-- <span class="badge badge-info text-white ml-1 mt-1">
                      ${{ estimatedCosts[input.value].estimatedCost.toFixed(6) }}
                    </span> -->
                  </template>
                </div>
                <div class="text-dark cursor-pointer cursor text-center" 
                  @click="getTranslation(index)" 
                  :class="[input.loading ? 'soft-blink' : '','shake-on-hover']"
                  v-else>
                  <!-- Show token usage once translation is done, hide it after timeout -->
                  <template v-if="input.usedTokens !== null && input.usedTokens !== undefined">
                    <span class=" ml-1 mt-1 font-weight-normal" style="font-size: 85%;">
                       {{ input.usedTokens }}  <img src="/img/languages/silom-token.png" style="width: 16px; height: 16px;" />
                    </span>
                  </template>
                </div>
              </div>
            </div>
        
            <!-- Trash -->
            <div @click="removeLanguage(index)" class="ml-2 mt-2 cursor-pointer">
              <CIcon name="cil-trash" class="text-danger" />
            </div>
          </div>
           <!-- <div v-for="(input, index) in translations">
            <div class="input-group ">
              <span class="input-group-text p-1"> <img :src="input.img"  style="width: 24px; height: auto" /></span>
              <input
                  type="text"
                  class="form-control" 
                  v-model="input.description"
                  :placeholder="`Enter product name (${defaultTranslation || 'undefined'})`"
                  :ref="'descName-' + index"
                  @input="autoResizeFromInput($event, index)"
                  :class="[input.isAnimating ? 'soft-blink' : 'no-blink']"
                  :readonly="input.isAnimating"
                  :disable="input.isAnimating"
                  :key="input.isAnimating + '-' + index"
                />
              <span class="input-group-text input-icon-right" style="padding: 0rem 0.2rem;">
                <small v-if="estimatedCosts[input.value]" class=" text-center">
                      ~ {{ estimatedCosts[input.value].tokenCount }}  <img src="/img/languages/silom-token.png" style="width: 16px; height: 16px;" class="mr-1" />
                  </small>
              </span>
              <span class="input-group-text input-icon-right" @click="getTranslation(index)" 
                style="padding: 0rem 0.2rem;">
                  <span  :class="[input.loading ? 'soft-blink' : '','shake-on-hover']" class="" > 
                    <img src="/img/languages/Ai.png"  style="width: 27px; height: auto" /> 
                  </span>
              </span>
              <span class="input-group-text input-icon-right">
                <div @click="removeLanguage(index)" class="cursor-pointer">
              <CIcon name="cil-trash" class="text-danger" />
            </div>
              </span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="custom-control custom-checkbox mt-1">
                  <input type="checkbox" class="custom-control-input" 
                    v-model="input.isTheSame" :id="'checkbox-' + index"
                    @change="handleCheckboxChange(input)" />
                  <label class="custom-control-label cursor" :for="'checkbox-' + index">
                    {{ $t('useDefault') }}
                  </label>
                </div>
                <div class="text-dark cursor-pointer cursor" 
                  @click="getTranslation(index)" 
                  :class="[input.loading ? 'soft-blink' : '','shake-on-hover']"
                  v-if="input.description === ''"
                >
                  <template v-if="estimatedCosts[input.value]" class="font-weight-normal text-center">
                    <span class="badge badge-light  text-center  ml-1 mt-1 font-weight-normal" style="font-size: 85%;">
                      
                      ~ {{ estimatedCosts[input.value].tokenCount }}  <img src="/img/languages/silom-token.png" style="width: 16px; height: 16px;" class="mr-1" />
                    </span>
                  </template>
                </div>
                <div class="text-dark cursor-pointer cursor text-center" 
                  @click="getTranslation(index)" 
                  :class="[input.loading ? 'soft-blink' : '','shake-on-hover']"
                  v-else>
                  <template v-if="input.usedTokens !== null && input.usedTokens !== undefined">
                    <span class="badge badge-light  ml-1 mt-1 font-weight-normal" style="font-size: 85%;">
                       {{ input.usedTokens }}  <img src="/img/languages/silom-token.png" style="width: 16px; height: 16px;" />
                    </span>
                  </template>
                </div>
              </div>
            </div> -->
        
       </div>
       <div v-else  :class="['card-body-background', translations.length <= 0 ? 'light-background' : '']"> 
        <!-- <img src="/img/languages/a1.png" class="img-fluid pt-2" style="width: 100%; height: auto;" /> -->
       </div>
      </CCardBody>
    </CCard>
  </modal>
</template>

<script>
import openrouter from '@/services/openrouterapi'
import Multiselect from 'vue-multiselect'
import util from "@/util/util";
export default {
  components: { Multiselect },
  props: {
    showModal: Boolean,
    defaultTranslation: String,
  
    translations: {
      type: Array,
      required: false, 
      default: () => [] 
    }
  },
  data() {
    return {
      newLanguage: '',
      localShowModal: this.showModal,
      languages: [
        { value: 'th', name: 'ไทย', img: '/img/languages/flag_TH01.png' },
        { value: 'en', name: 'English', img: '/img/languages/flag_EN01.png' },
        { value: 'lo', name: 'ລາວ', img: '/img/languages/flag_LA01.png' },
        { value: 'my', name: 'မြန်မာ', img: '/img/languages/flag_MM01.png' },
        { value: 'zh', name: 'Chinese', img: '/img/languages/flag_China01.png' },
        { value: 'ja', name: '日本語 (Japanese)', img: '/img/languages/flag_JP01.png' },
        { value: 'km', name: 'ភាសាខ្មែរ (Khmer)', img: '/img/languages/flag_Cambodia01.png' },
        { value: 'ko', name: '한국어', img: '/img/languages/ko.png' },
        { value: 'hi', name: 'हिन्दी (India)', img: '/img/languages/flag_India01.png' },
        { value: 'id', name: 'Bahasa Indonesia', img: '/img/languages/flag_Indo01.png' },
        { value: 'ar', name: 'العربية', img: '/img/languages/flag_Arab01.png' }
      ],
      isTranslating : false,
      isHovered: false,
      estimatedCosts: {},       // ค่า estimate รายภาษา
      totalTokenCount: 0,
      remainingTokens: 120,
      verifyModal: false,
      isTranslationEnabled: false, 
    };
  },
  created() {
    // this.getTranslation()
    // this.estimateTokens()
  },
  mounted() {
    this.translations.forEach(input => {
      if (input.loading === undefined) {
        this.$set(input, 'loading', false);
      }
    });
  },
  computed: {
    availableLanguages() {
      if (!Array.isArray(this.translations)) {
        return this.languages; // Return all languages if translations are undefined or not an array
      }
      return this.languages.filter(lang => !this.translations.some(sel => sel.value === lang.value));
    },
    //     localShowModal: {
    //         get() {
    //             return this.showModal; // Get prop value
    //         },
    //         set(value) {
    //             this.$emit('update:showModal', value); // Emit update to parent
    //         }
    //     }
  },
  watch: {
    showModal(newVal) {
    this.localShowModal = newVal;
      if (newVal) {
        // this.estimateTokens();
      }
    },
    localShowModal(newVal) {
      this.$emit('update:showModal', newVal);
    },
    translations: {
      handler() {
        // this.estimateTokens(); 
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    onSelectLanguage(lang) {
      if (!lang) return;
      this.$emit('addLanguage', lang);
      // เคลียร์ค่าเลือกเพื่อให้เลือกภาษาอื่นต่อได้ง่าย
      this.$nextTick(() => {
        if (this.$refs.langSelect) this.$refs.langSelect.clear();
      });
    },
    isRTL(lang) {
      return ['ar', 'he', 'fa', 'ur'].includes(lang);
    },
    getLangString() {
      return this.translations
        .map(t => t.value)
        .filter(Boolean)
        .join(',');
    },
    async estimateTokens() {
      const text = this.defaultTranslation;
      const to = this.getLangString();

      if (!text || !to) {
        console.warn("⚠️ Missing required fields for token estimate:", { text, to });
        return;
      }

      const headers = { shopObjectId: this.shopObjectId };
      const data = {
        text,
        to,
        model: 'openai/gpt-3.5-turbo'
      };

      try {
        const res = await openrouter({
          url: '/api/translate/token-estimate-list',
          headers,
          data,
          method: 'POST',
        });

        this.estimatedCosts = res.data?.data?.estimates || {};
        this.totalTokenCount = res.data?.data?.totalTokenCount || 0;
        this.showEstimates = true;
      } catch (err) {
        console.error('❌ Token Estimate Error:', err);
        this.showEstimates = false;
      }
    },
    async animateDescription(targetInput, text, totalTokens) {
        targetInput.isAnimating = true;
        targetInput.description = '';
        targetInput.usedTokens = totalTokens
        const words = text.split(' ');

        for (let i = 0; i < words.length; i++) {
          targetInput.description += words[i] + ' ';
          await new Promise(resolve => setTimeout(resolve, 120)); // สามารถปรับความเร็วได้
        }
        targetInput.isAnimating = false;
        this.$forceUpdate()
    },
    getTranslationAll() {
      if (!this.isTranslationEnabled) {
        console.log('⚠️ ฟังก์ชันแปลทั้งหมดถูกปิดไว้');
        return;
      }
      this.isTranslating = true;

      const shopObjectId = this.shopObjectId;
      const headers = {shopObjectId: util.sanitizeShopObjectId(shopObjectId)}

      const data = {
        text: this.defaultTranslation,
        to: this.getLangString()
      };

      openrouter({
        url: '/api/translate/translatemulti',
        headers,
        data,
        method: 'POST',
      })
        .then((res) => {
          const serverResults = res.data?.data?.translations || {};
          // อัปเดตคำแปล
          // this.languages.forEach((lang) => {
          //   const translatedText = serverResults[lang.value] || '';
          //   const existing = this.translations.find(t => t.value === lang.value);

          //   if (existing) {
          //     this.$set(existing, 'description', translatedText || existing.description);
          //   } else {
          //     this.translations.push({
          //       ...lang,
          //       description: translatedText || '',
          //       isTheSame: false,
          //       loading: false
          //     });
          //   }
          // });
          this.languages.forEach((lang) => {
            const translatedText = serverResults[lang.value] || '';
            const existing = this.translations.find(t => t.value === lang.value);

            if (existing) {
              this.$set(existing, 'description', translatedText || existing.description);
            } 
          });
        })
        .catch((err) => {
          console.error('❌ Translation error:', err);
        })
        .finally(() => {
          this.isTranslating = false;
          this.translations.forEach(t => t.loading = false);
        });
    },
    getTranslation(index) {
      if (!this.isTranslationEnabled) {
        console.log('⚠️ ฟังก์ชันแปลทีละภาษาถูกปิดไว้');
        return;
      }
      const input = this.translations[index];
      input.loading = true;
      this.loadingButton = false;
      input.loading = true;
      const shopObjectId = this.shopObjectId;
      const headers = {shopObjectId: util.sanitizeShopObjectId(shopObjectId)}

      const data = {
        text: this.defaultTranslation,
        to : input.value
      };

      openrouter({
        url: '/api/translate/check',
        headers,
        data,
        method: 'POST',
      })
        .then((res) => {
          console.log(res);
          
          const serverResults = res.data?.data?.translated || ""; // สำหรับ standardized response
          const totalTokens = res.data?.data?.usage?.total_tokens || 0;
          this.animateDescription(input, serverResults, totalTokens);
         
          this.loadingButton = true;
        })
        .catch((err) => {
          console.error('❌ Translation error:', err);
          this.loadingButton = true;
        })
        .finally(() => {
          input.loading = false;
        });
    },
    focusLanguageSelect() {
      this.$refs.languageSelect.toggleDropdown();
    },
    closeModal() {
      this.localShowModal = false; // Update local state, not the prop
    },
    addLanguage() {
      if (this.newLanguage) {
        this.$emit('addLanguage', this.newLanguage);
        this.newLanguage = '';
      }
    },
    removeLanguage(index) {
      this.$emit('removeLanguage', index);
    },
    handleCheckboxChange(input) {
      if (input.isTheSame) {
        input.description = this.defaultTranslation
      } else {
        input.description = ''
      }
    },

    // handleCheckboxChange(input) {
    //   this.$emit('handleCheckboxChange', input);
    // },
  }
};
</script>

<style scoped>
.lang-icon {
  padding-left: 5px;
  padding-top: 5px;
  align-items: unset;
  position: absolute;
  width: 42px;
  height: auto;
}
.language-input-wrapper {
  position: relative;

  .flag-icon-in-input {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    z-index: 1;
    border-radius: 3px;
  }

  input.form-control {
    padding-left: 48px !important; /* มีที่ให้ไอคอน */
  }

  .input-trash {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
  }
}
input .counter{
  position: absolute;
  right: 3px;
  width: 55px;
  color: #c4c4c4;
  text-align: center;
  border-left: 1px solid #d8d8d8;
  pointer-events: none;
}
.ai-icon {
  position: absolute;
  right: 30px;
  padding-bottom: 35px;
  transform: translateY(-50%);
  color: #3182ce;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 3;
}

.text-ai {
  margin-left: 2px;
}
.spinning {
  animation: spin 1s linear infinite ;
  display: inline-block; 
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.soft-blink {
    animation: softBlink 1.5s ease-in-out infinite;
    transition: opacity 0.3s ease;
    animation-fill-mode: none;
  }
  .no-blink {
    animation: none;
  }

@keyframes softBlink {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.5; }
}

@keyframes shake {
  0% { transform: translate(0px, 0px); }
  25% { transform: translate(2px, 0px); }
  50% { transform: translate(-2px, 0px); }
  75% { transform: translate(2px, 0px); }
  100% { transform: translate(0px, 0px); }
}

.shake-on-hover:hover {
  animation: shake 0.4s;
}

.card-body-background {
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  min-height: 300px;
  background-image: url('/img/languages/Translate-BY-AI_W02.jpg');
}

.card-body-background::before {
  content: "";
  position: absolute;
  top: 0; left: 0;
  right: 0; bottom: 0;
  background-color: rgba(255, 255, 255, 0.93); /* ปรับความโปร่งใสได้ */
  z-index: 1;
  pointer-events: none;
}

.card-body-background > * {
  position: relative;
  z-index: 2;
}
.light-background::before {
  background-color: rgba(255, 255, 255, 0.6); /* ปรับความโปร่งใสเบาลง */
}
.lang-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lang-flag {
  width: 20px;
  height: 14px;
  object-fit: cover;
  border-radius: 2px;
  box-shadow: 0 0 1px rgba(0,0,0,0.4);
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>